<template>
  <div class="hvh-flex">
    <FixedPlaceholder :component="TableauLeftMenu" />
    <div class="grow-1 overflow-hidden">
      <slot />
    </div>
  </div>
</template>

<script>
import FixedPlaceholder from '../common/fixedPlaceholder/FixedPlaceholder.vue';
import TableauLeftMenu from './TableauLeftMenu.vue';
export default {
  components: { FixedPlaceholder, },
  data() {
    return {
      TableauLeftMenu
    };
  },
}
</script>
